import { normalizarData, normalizarValor } from '../../utils/index';

const superNormalize = (h) => {
    return String(h || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
};

const superNormalizeNoSpace = (h) => {
    return superNormalize(h).replace(/[^a-z0-9]/g, '');
}

export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (
            cleanRow.includes('datadacompra') || cleanRow.includes('datadacompradatecreated') && 
            cleanRow.includes('datadeliberacaododinheiro') || cleanRow.includes('datadeliberacaododinheirodatereleased')
        ) {
            return true;
        }
    }
    return false;
};

export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let colMap = {};

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (cleanRow.includes('datadeliberacaododinheirodatereleased') || cleanRow.includes('datadeliberacaododinheiro')) {
            idxCabecalho = i;
            cleanRow.forEach((h, idx) => {
                if (h) colMap[h] = idx;
            });
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Repasses Mercado Pago não encontrado.');
    }

    const repasses = [];
    
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const idxStatusDetail = colMap['detalhedostatusdaoperacaostatusdetail'] || colMap['detalhedostatusdaoperacao'];
        if (idxStatusDetail !== undefined) {
            const statusDetail = String(linha[idxStatusDetail] || '').toLowerCase().trim();
            if (statusDetail !== 'accredited' && statusDetail !== 'approved' && statusDetail.includes('reject')) {
                continue;
            }
        }
        
        const idxStatus = colMap['statusdaoperacaostatus'] || colMap['statusdaoperacao'];
        if (idxStatus !== undefined) {
            const status = String(linha[idxStatus] || '').toLowerCase().trim();
            if (status === 'rejected') {
                continue;
            }
        }

        const idxFormaPagamento = colMap['meiodepagamentopaymenttype'] || colMap['meiodepagamento'];
        let formaPagamento = '';
        if (idxFormaPagamento !== undefined) {
            formaPagamento = String(linha[idxFormaPagamento] || '').trim();
            if (formaPagamento.toLowerCase() === 'bank_transfer' || formaPagamento.toLowerCase() === 'account_money' || formaPagamento.toLowerCase() === 'pix') {
                continue;
            }
        }

        const idxData = colMap['datadeliberacaododinheirodatereleased'] || colMap['datadeliberacaododinheiro'];
        const dataStrRaw = String(linha[idxData] || '').trim();
        if (!dataStrRaw) continue;
        
        const dataStr = dataStrRaw.split(' ')[0];
        const data = normalizarData(dataStr);
        if (!data) continue;

        const idxValor = colMap['valortotalrecebidonetreceivedamount'] || colMap['valortotalrecebido'];
        if (idxValor === undefined) continue;
        const valorRaw = linha[idxValor];
        const valor = normalizarValor(valorRaw);

        let tipoStr = 'Mercado Pago';
        const idxBandeira = colMap['bandeirafranchise'] || colMap['bandeira'];
        let bandeira = '';
        if (idxBandeira !== undefined) {
            bandeira = String(linha[idxBandeira] || '').trim();
        }

        let formatForma = formaPagamento;
        if (formaPagamento.includes('credit')) formatForma = 'Crédito';
        if (formaPagamento.includes('debit')) formatForma = 'Débito';

        if (formatForma || bandeira) {
            tipoStr = `${formatForma} ${bandeira}`.trim();
        }

        if (data && valor !== null && valor !== 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
